// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import GridItem from "@insite/mobius/GridItem";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import useLocalizeCurrency from "@store/Framework/Common/Hooks/useLocalizeCurrency";
import {
    ServiceHistoryInvoiceItemModel,
    ServiceHistoryInvoiceModel,
} from "@store/Framework/Services/Reporting/ReportingModels";
import AddToCartAndWishList from "@store/Library/Components/Reporting/AddToCartAndWishList/AddtoCartAndWishList";
import ReportDataTable, { DataTableData } from "@store/Library/Components/Reporting/ApiDataTable/ReportDataTable";

import React from "react";
import { css } from "styled-components";

const DataTableHeaders = ["SKU #", "Description", "U/M", "Ship Quantity", "Net Sales", "Price"];
const DataTableKeys: (keyof ServiceHistoryInvoiceItemModel)[] = [
    "sku",
    "description1",
    "unitOfMeasure",
    "shipQuantity",
    "netSales",
    "price",
];

const styles = {
    GridItemContainer: {
        css: css`
            display: flex;
            gap: 1rem;
            justify-content: space-between;
            align-items: flex-start;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: row;
                    `,
                    css`
                        flex-direction: row;
                    `,
                ]);
            }}
        `,
    },
    TypographyNotes: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        font-size: 1rem;
                    `,
                    css`
                        font-size: 1rem;
                    `,
                    css`
                        font-size: 1rem;
                    `,
                    css`
                        font-size: 0.75rem;
                    `,
                    css`
                        font-size: 0.875rem;
                    `,
                ]);
            }}
        `,
    },
};
interface Props {
    serviceHistoryInvoice: ServiceHistoryInvoiceModel;
}
const ServiceHistoryModelMainContent: React.FC<Props> = ({ serviceHistoryInvoice }) => {
    const data = serviceHistoryInvoice?.items ? serviceHistoryInvoice?.items : [];
    const localizeCurrency = useLocalizeCurrency();
    let formattedData: ServiceHistoryInvoiceItemModel[] = [];
    if (data.length > 0) {
        formattedData = data.map(item => {
            return { ...item, description1: `${item.description1.trim()}  ${item.description2}` };
        });
    }
    const dataTableData: DataTableData<ServiceHistoryInvoiceItemModel> = {
        headers: DataTableHeaders,
        dataKeys: DataTableKeys,
        data: formattedData,
        uniqueKey: "lineNumber",
        title: "",
        formatDictionary: {
            price: localizeCurrency,
        },
    };

    return (
        <GridItem {...styles.GridItemContainer} width={[12, 12, 12, 12, 12]}>
            <GridItem
                css={css`
                    margin-top: -1rem !important;
                `}
                width={[12, 12, 12, 9, 8]}
            >
                <ReportDataTable searchable={false} dataTableData={dataTableData} />
            </GridItem>
            <GridItem
                css={css`
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                `}
                width={[12, 12, 12, 3, 4]}
            >
                <Typography variant="h5">{translate("Notes:")}</Typography>
                <Typography variant="p" {...styles.TypographyNotes}>
                    {serviceHistoryInvoice.narrative}
                </Typography>
            </GridItem>
        </GridItem>
    );
};
export default ServiceHistoryModelMainContent;
